import { defineRouting } from "next-intl/routing";
import { hasLocale } from "next-intl";

export const routing = defineRouting({
  locales: ["en", "tw", "ja", "es"],
  defaultLocale: "en",
  localePrefix: "always",
});

export type Locale = (typeof routing.locales)[number];

/** Validate and resolve a locale string, falling back to the default locale. */
export function resolveLocale(raw: unknown): Locale {
  return typeof raw === "string" && hasLocale(routing.locales, raw)
    ? raw
    : (routing.defaultLocale as Locale);
}
